import styled from "@emotion/styled";
import { Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import { PageWithTitle } from "src/Common";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink } from "react-router-dom";
import { CRYPTOS_READ } from "../../../Api/endpoints";
import { getCryptosMarkedAsRead } from "../../../Api";
import { MarkedAsReadTable } from "../components/MarkedAsRead";
import { useQuery } from "react-query";

export const MarkedAsReadPage = () => {
  const { data, isLoading } = useQuery(CRYPTOS_READ, getCryptosMarkedAsRead);

  return (
    <PageWithTitle
      title={
        <Stack spacing={2}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link
              component={RouterLink}
              underline="hover"
              key="1"
              color="inherit"
              to="/arbitrage"
            >
              Arbitrage
            </Link>
            <Typography key="2" color="text.primary">
              Marked as read <Title>( {data?.length ?? 0} )</Title>
            </Typography>
          </Breadcrumbs>
        </Stack>
      }
      style={{ padding: "2rem 5%" }}
    >
      <MarkedAsReadTable data={data ?? []} isLoading={isLoading} />
    </PageWithTitle>
  );
};

const Title = styled.span(({ theme }: any) => ({
  color: theme.palette.primary.main,
  marginLeft: "5px",
}));
